import _ from 'lodash';
import { sdk as imagesSdk } from '@wix/image-kit';
import { parseBaseUrlsData } from '../utils/blocksConfigParser';
const SNAPSHOTTER_BASE_URL = 'https://images-wixmp-09d1505942a280459f0fa212.wixmp.com/images/wix-blocks-service';
const AddPanelThumbSizes = {
    width: 304,
    height: 188,
};
export const isPresetSectionItem = (sectionItem) => sectionItem.type === 'PRESET';
export const stripHash = (id) => _.trim(id, '#');
const unitSizeToNumber = (unitSize) => unitSize?.value ?? /* istanbul ignore next */ 300;
const defaultSizeToSize = (defaultSize) => ({
    width: unitSizeToNumber(defaultSize?.width),
    height: unitSizeToNumber(defaultSize?.height),
});
function getRevision(options) {
    if ('baseUrls' in options) {
        const parsed = parseBaseUrlsData(options.baseUrls);
        if (!parsed.revision) {
            throw new Error('revision is required, but can not be extracted from baseUrl');
        }
        return parsed.revision;
    }
    else if (options.revision) {
        return String(options.revision);
    }
    else {
        throw new Error('revision is required parameter. Provide it directly as argument or via baseUrls');
    }
}
export const generateWidgetThumbnail = ({ appDefinitionId, widgetId, presetId, size, ...otherOptions }) => {
    const revision = getRevision(otherOptions);
    const fileId = `widget-thumb/${appDefinitionId}/${widgetId}/${presetId}/rev${revision}`;
    const url = `${SNAPSHOTTER_BASE_URL}/${fileId}`;
    return size
        ? resizeThumbnail(url, size.width, size.height)
        : /* istanbul ignore next */ url;
};
const resizeThumbnail = (thumbnail, width, height) => `${thumbnail}/v1/fit/w_${width},h_${height},lg_0/file.jpg`;
export const generateSectionItems = ({ appDefinitionId, baseUrls, widgetDescriptor, id, mobilePresetId, presetsEditorPresence, }) => {
    const { name: title, variations, presets, devCenterWidgetId: widgetId, } = widgetDescriptor;
    if (!_.isEmpty(presets)) {
        return _.map(presets, (preset) => {
            const presetId = stripHash(preset.presetId);
            const presetEditorPresence = presetsEditorPresence?.find((p) => p.presetId ===
                (presetId ?? /* istanbul ignore next */ p.wixMediaThumbnail));
            const wixMediaThumbnail = presetEditorPresence?.wixMediaThumbnail;
            const image = wixMediaThumbnail
                ? imagesSdk.getScaleToFitImageURL(wixMediaThumbnail.url, wixMediaThumbnail.width, wixMediaThumbnail.height, AddPanelThumbSizes.width, AddPanelThumbSizes.height)
                : generateWidgetThumbnail({
                    appDefinitionId,
                    baseUrls,
                    widgetId: id,
                    presetId,
                    size: AddPanelThumbSizes,
                });
            return {
                type: 'PRESET',
                id,
                presetId: preset.presetId,
                title,
                desc: preset.name,
                size: defaultSizeToSize(preset.defaultSize),
                imageSource: 'URL',
                widgetId,
                image,
                appExtraData: {
                    presetId,
                    defaultSize: preset.defaultSize,
                },
                mobilePresetId: presetEditorPresence
                    ? presetEditorPresence?.mobilePresetId
                    : mobilePresetId,
            };
        });
    }
    if (!_.isEmpty(variations)) {
        return _.map(variations, (variation) => ({
            type: 'VARIATION',
            id,
            widgetId,
            presetId: stripHash(variation.rootCompId),
            title,
            desc: variation.name,
            appExtraData: {
                variationPageId: stripHash(variation.rootCompId),
            },
        }));
    }
    return [
        {
            type: 'BASE',
            widgetId,
            id,
            title,
        },
    ];
};
//# sourceMappingURL=addPanel.js.map